import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { ArrowLeft, Briefcase } from 'lucide-react';
import type { Project } from '@/store/AppContext';

import L from 'leaflet';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

const DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});

L.Marker.prototype.options.icon = DefaultIcon;

interface MapViewProps {
  onClose?: () => void;
  onProjects?: () => void;
  projects?: Project[];
}

export default function MapView({ onClose, onProjects, projects = [] }: MapViewProps) {
  const projectPoints = projects.filter((project) => (
    Number.isFinite(project.lat) && Number.isFinite(project.lng)
  ));
  const position: [number, number] = projectPoints[0]
    ? [projectPoints[0].lat as number, projectPoints[0].lng as number]
    : [53.7784, 20.4801];
  const heightClass = onClose ? 'h-[calc(100vh-100px)]' : 'h-[50vh]';

  return (
    <div className={`relative min-h-[400px] ${heightClass} w-full overflow-hidden rounded-3xl border-4 border-slate-800 shadow-2xl`}>
      {onClose && (
        <button
          type="button"
          onClick={onClose}
          className="absolute left-4 top-4 z-[1000] flex items-center gap-2 rounded-xl bg-slate-900/90 px-3 py-2 text-sm font-medium text-white shadow-lg backdrop-blur-sm transition-colors hover:bg-slate-800"
        >
          <ArrowLeft className="h-4 w-4" />
          {"Wr\u00f3\u0107"}
        </button>
      )}
      <MapContainer center={position} zoom={13} style={{ height: '100%', width: '100%' }}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {projectPoints.map((project) => (
          <Marker key={project.id} position={[project.lat as number, project.lng as number]}>
            <Popup>
              <strong>{project.name}</strong>
              <br />
              {project.location || 'Brak opisu lokalizacji'}
            </Popup>
          </Marker>
        ))}
      </MapContainer>
      {projectPoints.length === 0 && (
        <div className="absolute bottom-4 left-4 right-4 z-[1000] rounded-2xl border border-[#2a2f38] bg-[#0b0d10]/95 px-4 py-4 text-sm text-slate-200 shadow-lg backdrop-blur-sm">
          <p className="font-black text-white">{"Mapa pracy"}</p>
          <p className="mt-2 leading-6 text-slate-300">
            {"Mapa poka\u017ce projekty z dodan\u0105 lokalizacj\u0105. Dodaj lokalizacj\u0119 w projekcie, \u017ceby zobaczy\u0107 pinezk\u0119."}
          </p>
          {onProjects && (
            <button
              type="button"
              onClick={onProjects}
              className="mt-4 inline-flex min-h-11 items-center gap-2 rounded-xl bg-amber-500 px-4 text-sm font-black text-[#0b0d10] transition hover:bg-amber-400"
            >
              <Briefcase className="h-4 w-4" />
              {"Przejd\u017a do projekt\u00f3w"}
            </button>
          )}
        </div>
      )}
    </div>
  );
}
